import { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import FormPlayerContext from './PlayerContext';

function FormPlayerProvider({ children }) {
    const [player, setPlayer] = useState(null);
    const [timeOnSeek, setTimeOnSeek] = useState(0);
    const contextValue = useMemo(
        () => ({
            player,
            setPlayer,
            timeOnSeek,
            setTimeOnSeek,
        }),
        [player, setPlayer, timeOnSeek, setTimeOnSeek]
    );
    return <FormPlayerContext.Provider value={contextValue}>{children}</FormPlayerContext.Provider>;
}

FormPlayerProvider.propTypes = {
    children: PropTypes.node,
};

export default FormPlayerProvider;
